module.exports = "<ng-template [ngIf]=\"control\">\r\n  <div *ngIf=\"formError\" class=\"text-danger\" [ngClass]=\"className\">{{ formError }}</div>\r\n</ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/form-control-error/form-control-error.component.html
// module id = ./src/app/shared/components/form-control-error/form-control-error.component.html
// module chunks = main